/**
 * An enum value, said to a person (decision 117).
 *
 * Statuses are stored as the database spells them — `cancelled`,
 * `partially_received` — and that spelling is the API's contract, not copy.
 * What reaches the screen is this: underscores become spaces, and the one
 * value the database spells the British way is shown the American way.
 */
const SPOKEN: Readonly<Record<string, string>> = {
  cancelled: 'canceled',
};

export function statusLabel(status: string): string {
  return SPOKEN[status] ?? status.replace(/_/g, ' ');
}
